import { useState, useRef, useEffect, useCallback } from 'react';
import { Tooltip } from 'react-tooltip';

import * as validate from '../../utils/phoneValidation.js';
import useApi from '../../utils/useApi';
import 'react-tooltip/dist/react-tooltip.css';
import '../../css/common-components.css';
import '../../css/common-forms.css';
import '../../css/common-styles.css';
import loadIcon from '../../images/loader-transparent.svg';
import excelIcon from '../../images/excel_icon.svg';
import Toaster from '../Toaster/Toaster.jsx';
import Error from '../Error/Error.jsx';
import errorContent from '../../utils/ErrorMessages.js';
import InternationalPhoneInput from '../InternationalPhoneInput/InternationalPhoneInput.jsx';
import AddCC from '../CC/AddCC.jsx';
import FileUploadManager from '../FileUploadManager/FileUploadManager.jsx';
import { DEFAULT_COUNTRY } from '../../utils/flagsConfig.js';
import DocumentSettingsSection from '../DocumentSettings/DocumentSettings.jsx';
import MissingLocaleMessageDialogBox from '../MissingLocaleMessageDialogBox/MissingLocaleMessageDialogBox.jsx';

import styles from './TemplateCreate.module.css';

  const TemplateCreate = () => {
  const [popup, setPopup] = useState('')
  // Store all URL parameters in state
  const [objectType, setObjectType] = useState('');
  
  // Parse URL parameters on component mount
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      setObjectType(url.searchParams.get('objectType') || '');
      setPopup(url.searchParams.get('popup') || '');
    } catch (error) {
      console.error("Error parsing URL parameters:", error);
    }
  }, []);
  const api = useApi();
  const languageNames = {
    'EN': 'English',
    'ES': 'Spanish',
    'DE': 'German',
    'FR': 'French',
    'RO': 'Romanian',
    'NO': 'Norwegian',
    'BG': 'Bulgarian',
    'IT': 'Italian',
    'DA': 'Danish',
    'PL': 'Polish',
    'PT': 'Portuguese',
    'CS': 'Czech',
    'NL': 'Dutch',
    'RU': 'Russian',
    'SV': 'Swedish',
    'ZH_CN':'SimplifiedChinese',
    'ZH_TW':'TraditionalChinese',
    'JA':'Japanese',
    'TH':'Thai',
    'KO':'Korean'
  };
  const recipientRoles = [
    { id: 'signer', name: 'Signer', icon: <div className='signer-icon'></div> },
    { id: 'reviewer', name: 'Reviewer', icon: <div className='reviewer-icon'></div> }
  ];

  const MAX_RECIPIENTS = 50;

  const fixedColorSequence = [
  'rgb(253, 247, 219)',
  'rgb(214, 255, 221)',
  'rgb(217, 244, 254)',
  'rgb(244, 221, 255)',
  'rgb(221, 228, 255)',
  'rgb(219, 253, 247)'
];

	const [recipientColors, setRecipientColors] = useState(() => ({ 1: fixedColorSequence[0] }));
  
  const [recipients, setRecipients] = useState([
    { id: 1, roleName: '', signerName:'',signerEmail: '', iso: '', phone: '', fullPhone: '', countryCode: '', deliveryOption: 'Email', language: 'EN', roleType: 'signer', order: 1, showDeliveryOptions: false, showSettingsOptions: false, allowEditRecipient: true, allowDeleteRecipient: true, allowFieldConfigurationSetting: false, authType: 'none' }
  ]);
  
  const [signingOrder, setSigningOrder] = useState(false);
  const [templateDetails, setTemplateDetails] = useState({ title: '', message: '' });
  const [documents, setDocuments] = useState({ title: '', message: '' });
  // Per-locale document info (title + message) keyed by recipient locale.
  const [documentInfo, setDocumentInfo] = useState({});
  const [activeLocale, setActiveLocale] = useState('EN');

  const lastWrittenDocRef = useRef({ title: '', message: '' });
  const skipDocMirrorRef = useRef(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState({ type: null, id: null });
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [tempOrderValue, setTempOrderValue] = useState('');
  const [errors, setErrors] = useState({
    files: [],
    templateTitle: '',
    documentTitle: '',
    recipients: [],
    phone: '',
    cc: '',
    signerError: '',
    progressError: ''
  });
  const [ccRecipients, setCcRecipients] = useState('');
  const [ccEmailTags, setCcEmailTags] = useState([]);
  const [ccInputValue, setCcInputValue] = useState('');
  const [editingTagIndex, setEditingTagIndex] = useState(null);
  const [editingTagValue, setEditingTagValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [iframeSrc, setIframeSrc] = useState('');
  const [toasterMessage, setToasterMessage] = useState({ show: false, message: '', type: 'error' });
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [errorPageConfig, setErrorPageConfig] = useState({});
  const [hoveredRecipientId, setHoveredRecipientId] = useState(null);
  const [focusedInputId, setFocusedInputId] = useState(null);
  const hasIncompleteUploads = [...uploadedFiles, ...uploadingFiles].some(f => f.progress < 100);
  const [showLocaleMessageDialog, setShowLocaleMessageDialog] = useState(false);
  const [missingMessageLocales, setMissingMessageLocales] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [documentSettings, setDocumentSettings] = useState({
    brand: null,
    tags: [],
    enablePrintAndSign: false,
    enableReassign: true
  });
  const [templateTags, setTemplateTags] = useState([]);
  const [templateTagInput, setTemplateTagInput] = useState('');
  const [usageSettings, setUsageSettings] = useState({
    allowNewFiles: true,
    allowModifyFiles: false,
    allowNewRoles: true,
    allowMessageEditing: true,
    formFieldPermission: {
      canAdd: true,
      canModify: true,
      canModifyDefaultValue: false
    }
  });

  const uploadIntervalsRef = useRef({});
  const dropdownRefs = useRef({});
  const orderInputRef = useRef(null);
  const iframeRef = useRef(null);
  const editingTagRef = useRef(null);
  const recipientRowRefs = useRef({});
  const dragGhostRef = useRef(null);

  // Drag and drop state for signing order
  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const reorderRecipientsByDrag = useCallback((fromId, toId) => {
  if (fromId === null || toId === null || fromId === toId) return;
  const sorted = [...recipients].sort((a, b) => a.order - b.order);
  const fromIndex = sorted.findIndex(r => r.id === fromId);
  const toIndex = sorted.findIndex(r => r.id === toId);
  if (fromIndex === -1 || toIndex === -1) return;
  const [moved] = sorted.splice(fromIndex, 1);
  sorted.splice(toIndex, 0, moved);
  // Reassign order values and update the entire recipient list
  const updated = sorted.map((r, idx) => ({
    ...r,
    order: idx + 1
  }));
  setRecipients(updated);
}, [recipients]);
const onDragStartHandle = (e, id) => {
  if (!signingOrder) return;
  setDraggingId(id);
  try {
    e.dataTransfer.effectAllowed = 'move';
    const rowEl = recipientRowRefs.current[id];
    if (rowEl && e.dataTransfer.setDragImage) {
      const ghost = rowEl.cloneNode(true);
      // Apply shared styles via CSS class like DocumentSend
      ghost.classList.add('drag-ghost');
      // Preserve dynamic sizing via inline width to match the dragged element
      ghost.style.width = rowEl.offsetWidth + 'px';
      document.body.appendChild(ghost);
      dragGhostRef.current = ghost;
      const rect = rowEl.getBoundingClientRect();
      e.dataTransfer.setDragImage(ghost, rect.width/80, rect.height/80);
    }
  } catch {
    // ignore drag image compatibility issues
  }
};
const onDragOverRow = (e, targetId) => {
  if (!signingOrder) return;
  e.preventDefault();
  try { e.dataTransfer.dropEffect = 'move'; } catch {
    // ignore unsupported dropEffect
  }
  setDragOverId(prev => {
    if (draggingId !== null && targetId && targetId !== draggingId && targetId !== prev) {
      reorderRecipientsByDrag(draggingId, targetId);
    }
    return targetId ?? null;
  });
};
const onDropRow = (e, targetId) => {
  if (!signingOrder) return;
  e.preventDefault();
  if (draggingId !== null) {
    reorderRecipientsByDrag(draggingId, targetId);
  }
  setDraggingId(null);
  setDragOverId(null);
  if (dragGhostRef.current && dragGhostRef.current.parentNode) {
  try { dragGhostRef.current.parentNode.removeChild(dragGhostRef.current); } catch {
    // ignore DOM removal errors
  }
    dragGhostRef.current = null;
  }
};
const onDragEndHandle = () => {
  setDraggingId(null);
  setDragOverId(null);
  if (dragGhostRef.current && dragGhostRef.current.parentNode) {
  try { dragGhostRef.current.parentNode.removeChild(dragGhostRef.current); } catch {
    // ignore DOM removal errors
  }
    dragGhostRef.current = null;
  }
};

  // Handle iframe messages
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (data.action === "DONE") {
          // Forward to parent if needed
          window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
        }
      } catch (e) {
        console.error("Invalid message from iframe:", e);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Toaster functions
  const showToaster = (message, type = 'error') => {
    setToasterMessage({ show: true, message, type });
  };

  const hideToaster = () => {
    setToasterMessage({ show: false, message: '', type: 'error' });
  };

  const finishEditingOrder = useCallback(() => {
    if (editingOrderId === null) return;
      const newOrder = parseInt(tempOrderValue) || 1;
      const currentRecipient = recipients.find(r => r.id === editingOrderId);
      const currentOrder = currentRecipient ? currentRecipient.order : 1;
      if (newOrder === currentOrder) {
    
    setEditingOrderId(null);
    setTempOrderValue('');
      return;
  }
  const allOrders = recipients.map(r => r.order).sort((a, b) => a - b);
  let maxConsecutive = 0;
  for (let i = 1; i <= recipients.length; i++) {
    if (allOrders.includes(i)) {
      maxConsecutive = i;
    } else {
      break;
    }
  }
  const nextConsecutive = maxConsecutive + 1;
  const finalOrder = newOrder <= nextConsecutive ? newOrder : nextConsecutive;
  const updatedRecipients = recipients.map(recipient =>
    recipient.id === editingOrderId ? { ...recipient, order: finalOrder } : recipient
  );
  const uniqueOrders = [...new Set(updatedRecipients.map(r => r.order))].sort((a, b) => a - b);
  const orderMapping = {};
  uniqueOrders.forEach((order, index) => {
    orderMapping[order] = index + 1;
  });
  const compressedRecipients = updatedRecipients.map(recipient => ({
    ...recipient,
    order: orderMapping[recipient.order]
  }));
  const sortedRecipients = compressedRecipients.sort((a, b) => {
    if (a.order === b.order) {
      if (a.id === editingOrderId) return -1;
      if (b.id === editingOrderId) return 1;
      return 0;
    }
    return a.order - b.order;
  });
  setRecipients(sortedRecipients);
  setEditingOrderId(null);
  setTempOrderValue('');
}, [editingOrderId, tempOrderValue, recipients]);

  const toggleDropdown = (type, id) => {
    if (activeDropdown.type === type && activeDropdown.id === id) {
      setActiveDropdown({ type: null, id: null });
    } else {
      setActiveDropdown({ type, id });
    }
  };
  const addRecipient = () => {
  if (recipients.length >= MAX_RECIPIENTS) {
    return;
  }
  const newId = recipients.length > 0 ? Math.max(...recipients.map(r => r.id)) + 1 : 1;

  // Find the next available consecutive order
  const existingOrders = recipients.map(r => r.order).sort((a, b) => a - b);
  let newOrder = 1;
  while (existingOrders.includes(newOrder)) {
    newOrder++;
  }

  // Assign a unique color from the fixed sequence
  const usedColors = Object.values(recipientColors);

  const availableColor = fixedColorSequence.find(color => !usedColors.includes(color)) 
    || fixedColorSequence[recipients.length % fixedColorSequence.length];

    setRecipients([
      ...recipients,
      {
        id: newId,
        roleName: '',
        signerName: '',
        signerEmail: '',
        phone: '',
        fullPhone: '',
        countryCode: '',
        deliveryOption: 'Email',
        language: 'EN',
        roleType: 'signer',
        order: newOrder,
        showDeliveryOptions: false,
        allowEditRecipient: true,
        allowDeleteRecipient: true,
        allowFieldConfigurationSetting: false,
        showSettingsOptions: false,
        authType: 'none'
      }
    ]);
    
    // Assign color
    setRecipientColors(prev => ({ ...prev, [newId]: availableColor }));
    
    setErrors(prev => ({
      ...prev,
      recipients: [...(prev.recipients || []), { roleName: '', signerName: '', signerEmail: '' }]
    }));
  };

  const removeRecipient = (id) => {
  if (recipients.length > 1) {
    const index = recipients.findIndex(r => r.id === id);

    // Remove the recipient
    const remainingRecipients = recipients.filter(recipient => recipient.id !== id);

    // Normalize signer order to be consecutive starting from 1
    const sortedByOrder = [...remainingRecipients].sort((a, b) => a.order - b.order);
    const normalizedRecipients = sortedByOrder.map((recipient, idx) => ({
      ...recipient,
      order: idx + 1
    }));

    setRecipients(normalizedRecipients);

    // Remove corresponding error
    setErrors(prev => {
      const newRecipientErrors = [...prev.recipients];
      if (index !== -1) {
        newRecipientErrors.splice(index, 1);
      }
      return {
        ...prev,
        recipients: newRecipientErrors
      };
    });

    // Remove corresponding color
    setRecipientColors(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  }
};

  const updateRecipientPhone = (id, iso, countryCode, phone, fullPhone) => {
    // First update recipients
    setRecipients(prev =>
      prev.map(r =>
        r.id === id
          ? {
            ...r,
            iso: iso,
            countryCode: countryCode,
            phone: phone || '',
            fullPhone: phone ? fullPhone : countryCode
          }
          : r
      )
    );

    // Then update errors using CURRENT recipients
    setErrors(prev => {
      const newRecipientErrors = [...(prev.recipients || [])];
      const index = recipients.findIndex(r => r.id === id);
      if (index === -1) return prev;
      if (!newRecipientErrors[index]) {
        newRecipientErrors[index] = { phone: '' };
      }

      const recipient = recipients[index];

      // FIXED logic
      if (!recipient.allowEditRecipient && !phone) {
        newRecipientErrors[index].phone = 'Phone number is required';
      } 
      else if (phone && !validate.isValidPhoneNumber(countryCode + phone)) {
        newRecipientErrors[index].phone = 'Please enter a valid phone number';
      } 
      else {
        newRecipientErrors[index].phone = '';
      }

      return {
        ...prev,
        recipients: newRecipientErrors
      };
    });
  }
  useEffect(() => {
    if (!signingOrder) {
      setErrors(prev => {
        const newRecipientErrors = recipients.map(() => ({}));

        const phoneMap = {};

        recipients.forEach((r, i) => {
          const phoneKey = (r.countryCode + r.phone).replace(/\D/g, '');

          if (
            phoneKey &&
            (r.deliveryOption === 'SMS' || r.deliveryOption === 'EmailAndSMS')
          ) {
            if (!phoneMap[phoneKey]) phoneMap[phoneKey] = [];
            phoneMap[phoneKey].push(i);
          }
        });

        Object.values(phoneMap).forEach(indexes => {
          if (indexes.length === 2) {
            // Show error only on first
            newRecipientErrors[indexes[0]].phone = 'Recipient already exists';
          } else if (indexes.length > 2) {
            // Show error on all
            indexes.forEach(i => {
              newRecipientErrors[i].phone = 'Recipient already exists';
            });
          }
        });

        const emailMap = {};

        recipients.forEach((r, i) => {
          const email = r.signerEmail?.trim().toLowerCase();
          if (email) {
            if (!emailMap[email]) emailMap[email] = [];
            emailMap[email].push(i);
          }
        });

        Object.values(emailMap).forEach(indexes => {
          if (indexes.length === 2) {
            // Show error only on first
            newRecipientErrors[indexes[1]].signerEmail = 'Email already exists';
          } else if (indexes.length > 2) {
            // Show error on all
            indexes.forEach(i => {
              newRecipientErrors[0].signerEmail = '';
              newRecipientErrors[i].signerEmail = 'Email already exists';
            });
          }
        });

        return {
          ...prev,
          recipients: newRecipientErrors
        };
      });
    }
}, [signingOrder, recipients]);

  const handleDeliveryOptionChange = (recipientId, option) => {
    setRecipients(prev =>
      prev.map(r => {
        if (r.id !== recipientId) return r;

        let updated = {
          ...r,
          deliveryOption: option
        };

        // Determine whether the currently selected authType is still valid
        // for the new delivery option. If not, reset to the default ('none').
        const isEmailOtp = (r.authType || '').toLowerCase() === 'email';
        const isSmsOtp = (r.authType || '').toLowerCase() === 'sms';
        let authType = r.authType;
        if (option === 'SMS') {
          if (isEmailOtp) {
            authType = 'none';
          }
        } else if (option === 'Email') {
          if (isSmsOtp) {
            authType = 'none';
          }
        }

        updated.authType = authType;

        if (option === 'SMS' || option === 'EmailAndSMS') {
          if (!r.iso) {
            updated.iso = DEFAULT_COUNTRY;
            updated.countryCode = '+1';
            updated.phone = '';
            updated.fullPhone = '';
          }
          if (option === 'SMS') {
            updated.signerEmail = '';
          }
        }
        if (option === 'Email') {
          updated.phone = '';
          updated.fullPhone = '';
          updated.countryCode = '';
        }

        return updated;
      })
    );
    setErrors(prev => {
      const idx = recipients.findIndex(r => r.id === recipientId);
      if (idx === -1) return prev;

      const updatedErrors = [...prev.recipients];
      if (!updatedErrors[idx]) updatedErrors[idx] = {};

      if (option === 'SMS') {
        updatedErrors[idx].email = '';
      }

      if (option === 'Email') {
        updatedErrors[idx].phone = '';
      }

      return { ...prev, recipients: updatedErrors };
    });
  };
  const updateRecipient = (id, field, value) => {
    const index = recipients.findIndex(r => r.id === id);
    if (index === -1) return;
    const recipient = recipients[index];
    // Create updated recipients list
    const updatedRecipients = recipients.map(recipient =>
      recipient.id === id ? { ...recipient, [field]: value } : recipient
    );
    
    setRecipients(updatedRecipients);
    
    // If updating the email field, set inline error when this email exists in CC
    if (field === 'signerEmail') {
      const trimmed = (value || '').trim();
      if (trimmed && isValidEmail(trimmed)) {
        const emailToCheck = trimmed.toLowerCase();
        const emailExistsInCC = ccEmailTags.some(ccEmail => ccEmail.toLowerCase() === emailToCheck);
        if (emailExistsInCC && index !== -1) {
          setErrors(prev => {
            const newRecipientErrors = [...(prev.recipients || [])];
            if (!newRecipientErrors[index]) newRecipientErrors[index] = { roleName: '', signerName: '', signerEmail: '' };
            newRecipientErrors[index].signerEmail = 'Recipient already exists in CC';
            return { ...prev, recipients: newRecipientErrors };
          });
        }
      }
    }

    // Validate in real-time for optional fields
    if (index !== -1) {
      setErrors(prev => {
        const newRecipientErrors = [...prev.recipients];
        
        // Ensure error object exists for this recipient
        if (!newRecipientErrors[index]) {
          newRecipientErrors[index] = { roleName: '', signerName: '', signerEmail: '' };
        }
        
        // Handle validation based on field type
        if (field === 'signerEmail') {
          const trimmedVal = (value || '').trim();

          // Required validation
          if (!updatedRecipients[index].allowEditRecipient && trimmedVal === '') {
            newRecipientErrors[index].signerEmail = 'Email is required';
          } 
          // Invalid format
          else if (trimmedVal !== '' && !isValidEmail(trimmedVal)) {
            newRecipientErrors[index].signerEmail = 'Please enter a valid email';
          } 
          // Valid email
          else if (trimmedVal && isValidEmail(trimmedVal)) {
            const existsInCC = ccEmailTags.some(e =>
              e.toLowerCase() === trimmedVal.toLowerCase()
            );
          
            if (existsInCC) {
              newRecipientErrors[index].signerEmail = 'Recipient already exists in CC';
            } else {
              const isDuplicate = updatedRecipients.some((r, i) => i !== index && r.signerEmail && r.signerEmail.trim().toLowerCase() === trimmedVal.toLowerCase());

              newRecipientErrors[index].signerEmail = isDuplicate && !signingOrder ? 'Email already exists' : '';
            }
          }
        } else if (field === 'signerName') {
            const trimmed = value.trim();
            if (!recipient.allowEditRecipient && trimmed === '') {
              newRecipientErrors[index].signerName = 'Name is required';
            } 
            else {
              newRecipientErrors[index].signerName = '';
            }
        } else if (field === 'roleName') {
          // Clear role name error when user types (required field)
          newRecipientErrors[index] = { ...newRecipientErrors[index], roleName: '' };
        }

        return {
          ...prev,
          recipients: newRecipientErrors
        };
      });
    }
    
    setActiveDropdown({ type: null, id: null });
  };
  const startEditingOrder = (id, currentOrder) => {
    if (!signingOrder) return;
    setEditingOrderId(id);
    setTempOrderValue(currentOrder.toString());
  };
  const handleOrderChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setTempOrderValue(value);
  };
  const handleOrderKeyPress = (e) => {
    if (e.key === 'Enter') {
      finishEditingOrder();
    }
  };
  // Get role icon by ID
  const getRoleIcon = (roleId) => {
    const role = recipientRoles.find(r => r.id === roleId);
    return role ? role.icon : <div className='signer-icon'></div>;
  };
  // Display-only conversion for language code: show hyphen in UI, keep underscore in values
  const getDisplayLanguageCode = (code) => {
    if (!code) return '';
    return code.replace('_', '-');
  };
  const isValidEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const getUniqueRecipientLocales = useCallback(() => {
    const seen = [];
    recipients.forEach((r) => {
      const locale = r.language || r.locale;
      if (locale && !seen.includes(locale)) seen.push(locale);
    });
    return seen;
  }, [recipients]);

  // Returns the list of unique locales whose message is currently empty.
  const getLocalesWithMissingMessage = useCallback(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length < 2) return [];
    return uniqueLocales.filter((loc) => !((documentInfo[loc]?.message || '').trim()));
  }, [getUniqueRecipientLocales, documentInfo]);

  useEffect(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length === 0) return;

    setDocumentInfo((prev) => {
      const seedTitle = (prev[uniqueLocales[0]] && prev[uniqueLocales[0]].title) || documents.title || '';
      const next = {};
      uniqueLocales.forEach((loc) => {
        if (prev[loc]) {
          next[loc] = prev[loc];
        } else {
          next[loc] = { title: seedTitle, message: '' };
        }
      });
      return next;
    });
    setActiveLocale((prev) => (uniqueLocales.includes(prev) ? prev : uniqueLocales[0]));
  }, [getUniqueRecipientLocales, documents.title, documents.message]);

  useEffect(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length === 0) return;
    const active = documentInfo[activeLocale] || { title: '', message: '' };
    if (skipDocMirrorRef.current) {
      skipDocMirrorRef.current = false;
      lastWrittenDocRef.current = { title: active.title || '', message: active.message || '' };
      return;
    }
    const nextTitle = active.title || '';
    const nextMessage = active.message || '';
    if (lastWrittenDocRef.current.title !== nextTitle
        || lastWrittenDocRef.current.message !== nextMessage) {
      lastWrittenDocRef.current = { title: nextTitle, message: nextMessage };
      setDocuments({ title: nextTitle, message: nextMessage });
    }
  }, [documentInfo, activeLocale, getUniqueRecipientLocales]);

  useEffect(() => {
    const uniqueLocales = getUniqueRecipientLocales();
    if (uniqueLocales.length === 0) return;
    const last = lastWrittenDocRef.current;
    if (documents.title === last.title && documents.message === last.message) {
      return;
    }
    lastWrittenDocRef.current = { title: documents.title, message: documents.message };
    skipDocMirrorRef.current = true;
    setDocumentInfo((prev) => {
      const allTitlesEmpty = uniqueLocales.every((locale) => !(prev[locale]?.title || '').trim());
      const allTitlesMatchPrevious = uniqueLocales.every(
        locale => (prev[locale]?.title || '') === last.title
      );
      if ((allTitlesEmpty || allTitlesMatchPrevious) && documents.title.trim()) {
        const next = { ...prev };
        uniqueLocales.forEach((locale) => {
          next[locale] = {
            ...(prev[locale] || { title: '', message: '' }),
            title: documents.title
          };
        });
        return next;
      }

      const targetLocale = uniqueLocales.length === 1 ? uniqueLocales[0] : activeLocale;
      const current = prev[targetLocale] || { title: '', message: '' };
      if (current.title === documents.title && current.message === documents.message) return prev;
      return {
        ...prev,
        [targetLocale]: { title: documents.title, message: documents.message }
      };
    });

  }, [documents.title, documents.message]);
  useEffect(() => {
    if (uploadedFiles.length !== 0 || uploadingFiles.length !== 0) return;
    setDocumentInfo(prev => {
      const locales = getUniqueRecipientLocales();
      if (locales.length === 0) return prev;
      const next = { ...prev };
      locales.forEach(locale => {
        next[locale] = { ...(next[locale] || { title: '', message: '' }), title: '' };
      });
      return next;
    });
    setDocuments(prev => (prev.title ? { ...prev, title: '' } : prev));
    lastWrittenDocRef.current = { title: '', message: documents.message };
  }, [uploadedFiles.length, uploadingFiles.length, getUniqueRecipientLocales]);

  const updateDocumentInfoField = (locale, field, value, currentInfo) => {
    const title = field === 'title' ? value : currentInfo.title || '';
    const message = field === 'message' ? value : currentInfo.message || '';

    skipDocMirrorRef.current = false;
    if (locale) {
      setDocumentInfo(prev => ({
        ...prev,
        [locale]: {
          ...(prev[locale] || { title: '', message: '' }),
          [field]: value
        }
      }));
    }
    skipDocMirrorRef.current = true;
    setDocuments(prev => ({ ...prev, [field]: value }));
    lastWrittenDocRef.current = { title, message };

    if (field === 'title' && errors.documentTitle) {
      setErrors(prev => ({ ...prev, documentTitle: '' }));
    }
  };

  const updateCcRecipientsFromTags = (tags) => {
    setCcRecipients(tags.join(', '));
  };

  // CC limit
  const MAX_CC_RECIPIENTS = 20;

  // Clear duplicate errors when signing order is toggled
  useEffect(() => {
    setErrors(prev => {
      if (!prev.recipients) return prev;

      const newRecipientErrors = prev.recipients.map(err => ({
        ...err,
        phone:
          signingOrder && err.phone === 'Recipient already exists'
            ? ''
            : err.phone,

        signerEmail:
          signingOrder && err.signerEmail === 'Email already exists'
            ? ''
            : err.signerEmail
      }));

      return { ...prev, recipients: newRecipientErrors };
    });
  }, [signingOrder]);

  // Clear recipient email errors if their email is no longer in CC or duplicate
  useEffect(() => {
  setErrors(prev => {
    if (!prev.recipients || prev.recipients.length === 0) return prev;

    const ccEmailsLower = ccEmailTags.map(e => e.toLowerCase());

    const newRecipientErrors = prev.recipients.map((err, idx) => {
      if (!recipients[idx] || !err) return err;

      const email = recipients[idx].signerEmail ? recipients[idx].signerEmail.toLowerCase() : '';

      let newErr = { ...err };

      if (email && ccEmailsLower.includes(email)) {
        newErr.signerEmail = 'Recipient already exists in CC';
        return newErr;
      }

      if (email) {
        const isDuplicate = recipients.some(
          (r, i) =>
            i !== idx &&
            r.signerEmail &&
            r.signerEmail.trim().toLowerCase() === email
        );

        if (isDuplicate) {
          newErr.signerEmail = 'Email already exists';
          return newErr;
        }
      }

      if (
        newErr.signerEmail === 'Recipient already exists in CC' ||
        newErr.signerEmail === 'Email already exists'
      ) {
        newErr.signerEmail = '';
      }

      return newErr;
    });

    return { ...prev, recipients: newRecipientErrors };
  });
}, [ccEmailTags, recipients]);

  // Toggle delivery options visibility based on checkbox
  const toggleOption = (recipientId, type) => {
    setRecipients(prev =>
      prev.map(r => {
        if (r.id !== recipientId) return r;

        if (type === "delivery") {
          return {
            ...r,
            showDeliveryOptions: !r.showDeliveryOptions,
            showSettingsOptions: false
          };
        }

        if (type === "settings") {
          return {
            ...r,
            showSettingsOptions: !r.showSettingsOptions,
            showDeliveryOptions: false
          };
        }

        return r;
      })
    );
  };
  useEffect(() => {
    const loadBrands = async () => {
      try {
        const response = await api.get('/boldsign/get-brand-details');
        if (response.status === 200) {
          const data = await response.data;
          const normalized = Array.isArray(data)
            ? data.map(b => ({
                id: b.brandId,
                brandName: b.brandName,
                isDefault: b.isDefault
              }))
            : [];

          setBrandsList(normalized);
        }
      } catch (error) {
        console.error('Failed to load brands', error);
      }
    };
    loadBrands();
  }, []);
  const handleSettingsChange = useCallback((changedSettings) => {
  setDocumentSettings(prev => ({
    ...prev,
    ...changedSettings
  }));
}, []);

  const addTemplateTags = useCallback((value) => {
    const parsedTags = value
      .split(/[,\n\r]+/)
      .map(tag => tag.trim())
      .filter(Boolean);

    if (parsedTags.length > 0) {
      setTemplateTags(prev => [...new Set([...prev, ...parsedTags])].slice(0, 50));
    }
    setTemplateTagInput('');
  }, []);

  const handleTemplateTagKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      addTemplateTags(templateTagInput);
    } else if (event.key === 'Backspace' && !templateTagInput && templateTags.length > 0) {
      setTemplateTags(prev => prev.slice(0, -1));
    }
  };

  const handleTemplateTagPaste = (event) => {
    event.preventDefault();
    addTemplateTags(event.clipboardData.getData('text'));
  };

  const handleUsageSettingChange = (key) => {
    setUsageSettings(prev => {
      if (key.startsWith('formFieldPermission.')) {
        const permissionKey = key.split('.')[1];
        const nextValue = !prev.formFieldPermission[permissionKey];
        return {
          ...prev,
          formFieldPermission: {
            ...prev.formFieldPermission,
            [permissionKey]: nextValue,
            ...(permissionKey === 'canModify' && nextValue ? { canModifyDefaultValue: false } : {})
          }
        };
      }

      return { ...prev, [key]: !prev[key] };
    });
  };

  const handleAuthTypeChange = (id, value) => {
    setRecipients(prev =>
      prev.map(r =>
        r.id === id
          ? { ...r, authType: value }
          : r
      )
    );
  };

  const handleRecipientAccess = (id, type) => {
    setRecipients(prev =>
      prev.map(r => {
        if (r.id !== id) return r;

        // Toggle Edit
        if (type === "edit") {
          const newEditValue = !r.allowEditRecipient;

          return {
            ...r,
            allowEditRecipient: newEditValue,
            // If Edit is unchecked → force Delete OFF
            allowDeleteRecipient: newEditValue ? true : false
          };
        }

        // Toggle Delete (only if Edit is ON)
        if (type === "delete") {
          if (!r.allowEditRecipient) return r; // blocked

          return {
            ...r,
            allowDeleteRecipient: !r.allowDeleteRecipient
          };
        }

        // Other toggles
        if (type === "fieldConfig") {
          return {
            ...r,
            allowFieldConfigurationSetting: !r.allowFieldConfigurationSetting
          };
        }

        return r;
      })
    );
  };

  const authTypeToShow = (recipient) => {
    if (recipient.authType === 'accessCode') {
      if (!recipient.accessCode) {
        return {
          text: 'Access code enabled but value not filled',
          isError: true
        };
      }
      return {
        text: 'Access Code',
        isError: false
      };
    }

    if (recipient.authType === 'email') {
      return {
        text: 'Email OTP',
        isError: false
      };
    }

    if (recipient.authType === 'SMS') {
      if (!recipient.phone) {
        return {
          text: 'Please enter a valid phone number',
          isError: true
        };
      }
      return {
        text: 'SMS OTP',
        isError: false
      };
    }

    return { text: '', isError: false };
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      files: '',
      templateTitle: '',
      documentTitle: '',
      recipients: [...recipients.map(() => ({ roleName: '', signerName: '', signerEmail: '', phone: '' }))],
      cc: ''
    };

    // Validate files
    const totalFiles = uploadedFiles.length + uploadingFiles.length;
    if (totalFiles === 0) {
      newErrors.files = 'At least one document is required.';
      isValid = false;
    } 

    // Validate title fields
    const documentTitle = documents.title.trim();
    const templateTitle = templateDetails.title.trim();

    if (!templateTitle) {
      newErrors.templateTitle = 'Template title is required';
      isValid = false;
    }

    // Validate per-locale document title when more than one locale is present.
    {
      const uniqueLocalesValidate = getUniqueRecipientLocales();
      if (uniqueLocalesValidate.length > 1) {
        const missing = uniqueLocalesValidate
          .filter((loc) => !((documentInfo[loc] && documentInfo[loc].title) || '').trim())
          .map((loc) => `${languageNames[loc] || loc}`);
        if (missing.length > 0) {
          newErrors.documentTitle = `Document title is required for: ${missing.join(', ')}`;
          isValid = false;
        }
      } else if (!documentTitle) {
        newErrors.documentTitle = 'Document title is required';
        isValid = false;
      }
    }

    // Validate recipients
    const emails = new Set();
    const phones = new Set();
    recipients.forEach((recipient, index) => {
      if (!recipient.roleName.trim()) {
        newErrors.recipients[index].roleName = 'Role name is required';
        isValid = false;
      }

      const email = recipient.signerEmail.trim().toLowerCase();
      if (email) {
        if (!isValidEmail(email)) {
          newErrors.recipients[index].signerEmail = 'Please enter a valid email';
          isValid = false;
        } else if (emails.has(email) && !signingOrder) {
          newErrors.recipients[index].signerEmail = 'Email already exists';
          isValid = false;
        } else {
          emails.add(email);
        }
      }

      if (recipient.deliveryOption !== 'Email') {
        const fullPhone = recipient.countryCode + recipient.phone;

        if (!recipient.allowEditRecipient && !recipient.phone) {
          newErrors.recipients[index].phone = 'Phone number is required';
          isValid = false;
        } 
        else if (recipient.phone && !validate.isValidPhoneNumber(fullPhone)) {
          newErrors.recipients[index].phone = 'Please enter a valid phone number';
          isValid = false;
        } 
        else if (!signingOrder && fullPhone && phones.has(fullPhone.replace(/\D/g, ''))) {
          newErrors.recipients[index].phone = 'Recipient already exists';
          isValid = false;
        } 
        else {
          newErrors.recipients[index].phone = '';
          if (recipient.phone) {
            phones.add(fullPhone.replace(/\D/g, ''));
          }
        }
      }
      if (recipient.authSetting && recipient.authType === 'SMS' && !recipient.phone) {
        newErrors.recipients[index].phone = !recipient.phone ? 'Phone number is required' : 'Please enter a valid phone number'
        isValid = false;
      }
      if (recipient.authSetting && recipient.authType === 'accessCode' && !recipient.accessCode) {
        isValid = false;
      }
      // REQUIRED validation when allowEditRecipient = false
      if (!recipient.allowEditRecipient) {
        if (!recipient.signerName || !recipient.signerName.trim()) {
          newErrors.recipients[index].signerName = "Name is required";
          isValid = false;
        }
      
        if ((recipient.deliveryOption === 'Email' || recipient.deliveryOption === 'EmailAndSMS') &&(!recipient.signerEmail || !recipient.signerEmail.trim()))
        {
          newErrors.recipients[index].signerEmail = "Email is required";
          isValid = false;
        }
      }
    });
    
    // Ensure at least one signer exists
    if (!recipients.some(r => r.roleType === 'signer')) {
      newErrors.signerError = 'You need to assign atleast one signer for a document';
      isValid = false;
    } else {
      newErrors.signerError = '';
    }
    
    // Validate CC field
    if (ccInputValue && !isValidEmail(ccInputValue.trim())) {
      newErrors.cc = 'Please enter a valid email address';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const submitTemplateCreate = async () => {
    setIsLoading(true);

    try {
      // Prepare FormData to send to the API
      const formData = new FormData();

      // First, collect all unique locales from recipients
      const uniqueLocales = [...new Set(recipients.map(recipient => recipient.language))];

      // Add files to the formData
      for (let i = 0; i < uploadedFiles.length; i++) {
        formData.append('files', uploadedFiles[i].file);
      }

      // Add template metadata using proper field names from TemplateCreateRequest
      formData.append('title', templateDetails.title); // Template title field
      formData.append('description', templateDetails.message); // Template description
      
      // Then create DocumentInfo entries for each unique locale
      const firstLocale = uniqueLocales[0];
      const info = documentInfo[firstLocale];
      // Add document metadata
      formData.append('documentTitle', info.title); // Document title field

      // Set redirect URL
      const redirect = window.location.origin + '/templateMapping';
      formData.append('redirectUrl', popup ? redirect + '?popup=1' : redirect);
      // Enable signing order flag
      formData.append('enableSigningOrder', signingOrder ? 'true' : 'false');

      // Process CC recipients - send as individual ccEmails entries
      if (ccEmailTags.length > 0) {
        ccEmailTags.forEach((email) => {
          formData.append('ccEmails', email);
        });
      }

      // Add recipients as roles
      recipients.forEach((recipient, index) => {
        formData.append(`roles[${index}].name`, recipient.roleName);
        formData.append(`roles[${index}].defaultSignerName`, recipient.signerName);
        formData.append(`roles[${index}].locale`, recipient.language);
        formData.append(`roles[${index}].signerType`, recipient.roleType);
        formData.append(`roles[${index}].index`, index + 1);
        if (signingOrder) {
          formData.append(`roles[${index}].signerOrder`, recipient.order || index + 1);
        }

        // Delivery Mode (Email or SMS or EmailAndSMS)
        formData.append(`roles[${index}].deliveryMode`,recipient.deliveryOption);

        if (recipient.deliveryOption === 'Email') {
          formData.append(`roles[${index}].defaultSignerEmail`, recipient.signerEmail);
          formData.append(`roles[${index}].PhoneNumber.number`, '');
          formData.append(`roles[${index}].PhoneNumber.countryCode`, '');
        } else if (recipient.deliveryOption === 'SMS') {
          formData.append(`roles[${index}].defaultSignerEmail`, '');
          formData.append(`roles[${index}].PhoneNumber.number`, recipient.phone);
          formData.append(`roles[${index}].PhoneNumber.countryCode`, recipient.countryCode);
        } else {
          formData.append(`roles[${index}].defaultSignerEmail`, recipient.signerEmail);
          formData.append(`roles[${index}].PhoneNumber.number`, recipient.phone);
          formData.append(`roles[${index}].PhoneNumber.countryCode`, recipient.countryCode);
        }
        if (recipient.authType === 'SMS') {
          formData.append(`roles[${index}].imposeAuthentication`, 'SMSOTP');
        }
        if (recipient.authType === 'email') {
          formData.append(`roles[${index}].imposeAuthentication`, 'EmailOTP');
        }
        if (recipient.authType === 'accessCode') {
          formData.append(`roles[${index}].imposeAuthentication`, 'AccessCode');
        }
        if (recipient.allowFieldConfigurationSetting) {
          formData.append(`roles[${index}].allowFieldConfiguration`, recipient.roleType === 'reviewer' ? false : recipient.allowFieldConfigurationSetting);
        }
        formData.append(`roles[${index}].allowRoleEdit`, recipient.allowEditRecipient);
        formData.append(`roles[${index}].allowRoleDelete`, recipient.allowDeleteRecipient);
      });

      // Then create DocumentInfo entries for each unique locale
      uniqueLocales.forEach((locale, index) => {
        const info = documentInfo[locale] || { title: documents.title, message: documents.message };
        formData.append(`documentInfo[${index}].locale`, locale);
        formData.append(`documentInfo[${index}].title`, info.title || '');
        if (info.message && info.message.trim() !== '' && uniqueLocales.length > 1) {
          formData.append(`documentInfo[${index}].description`, info.message);
        }
      });

      formData.append('objectType', objectType.toLowerCase());

      if (documentSettings.brand && documentSettings.brand.id) {
        formData.append('brandId', documentSettings.brand.id);
      }

      formData.append('enablePrintAndSign', documentSettings.enablePrintAndSign);
      formData.append('enableReassign', documentSettings.enableReassign);
      formData.append('labels', documentSettings.tags);
      templateTags.forEach(tag => {
        formData.append('templateLabels', tag);
      });
      formData.append('allowNewFiles', usageSettings.allowNewFiles);
      formData.append('allowModifyFiles', usageSettings.allowModifyFiles);
      formData.append('allowNewRoles', usageSettings.allowNewRoles);
      formData.append('allowMessageEditing', usageSettings.allowMessageEditing);
      formData.append('formFieldPermission.canAdd', usageSettings.formFieldPermission.canAdd);
      formData.append('formFieldPermission.canModify', usageSettings.formFieldPermission.canModify);
      formData.append('formFieldPermission.canModifyDefaultValue', usageSettings.formFieldPermission.canModifyDefaultValue);

      // Send to API
      const response = await api.post(`/boldsign/create-template`, formData);

      if (response.status !== 200) {
        const errorText = await response.data;
        console.error('Error response:', response.status, errorText);

        // Show Error page with Template Creation Failed message
        setErrorPageConfig({
          title: errorContent.createTemplate.title,
          message: errorContent.createTemplate.message
        });
        setShowErrorPage(true);
        return;
      }

      const jsonResponse = await response.data;

      // Remove quotes from the documentUrl before setting iframe src
      const templateId = jsonResponse.templateId;
      const createUrl = jsonResponse.createUrl;

      sessionStorage.setItem("templateId",templateId);
      if (objectType) sessionStorage.setItem("hs_object",objectType);
      if (popup) sessionStorage.setItem("popup","1");

      // Set the iframe URL from the response
      if (createUrl) {
        setIframeSrc(createUrl);
        setCurrentStep(2); // Move to iframe display step
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Error processing documents:', error);
      // Show Error page for client-side/network failures as well
      setErrorPageConfig({
        title: errorContent.createTemplate.title,
        message: errorContent.createTemplate.message
      });
      setShowErrorPage(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNextButtonClick = async () => {
    if (isLoading) return;

    if (hasIncompleteUploads) {
        setErrors(prev => ({
          ...prev,
          progressError: 'Some of the uploaded file(s) are not completed.'
        }));
        return;
      }

    if (validateForm()) {
      // When more than one unique locale is present, prompt the user before
      // proceeding if any locale has an empty message.
      const missingLocales = getLocalesWithMissingMessage();
      if (missingLocales.length > 0) {
        setMissingMessageLocales(missingLocales);
        setShowLocaleMessageDialog(true);
        return;
      }

      await submitTemplateCreate();
    }
  };

  const closeLocaleMessageDialog = () => {
    setShowLocaleMessageDialog(false);
    setMissingMessageLocales([]);
  };
  const handleLocaleMessageDialogYes = async () => {
    setShowLocaleMessageDialog(false);
    setMissingMessageLocales([]);
    await submitTemplateCreate();
  };

  // Handle error page button click
  const handleErrorPageButtonClick = () => {
    // Send DONE message to parent to close the modal/iframe
    try {
      window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
    } catch (error) {
      console.error("Error occurred when return to HubSpot:", error);
      // Fallback: try to go back in history
      if (window.history.length > 1) {
        window.history.back();
      }
    }
  };

  useEffect(() => {
    if (!hasIncompleteUploads && errors.progressError) {
      setErrors(prev => ({
        ...prev,
        progressError: ''
      }));
    }
  }, [hasIncompleteUploads, errors.progressError]);
  // Show error page if needed
  if (showErrorPage) {
    return (
      <Error
        title={errorPageConfig.title}
        message={errorPageConfig.message}
        buttonText={errorPageConfig.buttonText}
        onButtonClick={handleErrorPageButtonClick}
      />
    );
  }

  return (
    <div className={styles.documentSendContainer}>
      {/* Toaster Component */}
      <Toaster
        show={toasterMessage.show}
        message={toasterMessage.message}
        type={toasterMessage.type}
        onClose={hideToaster}
        autoHide={true}
        autoHideDelay={3000}
      />

      {/* Locale message missing confirmation dialog */}
      <MissingLocaleMessageDialogBox
        show={showLocaleMessageDialog}
        localeCodes={missingMessageLocales}
        languageNames={languageNames}
        onClose={closeLocaleMessageDialog}
        onNo={closeLocaleMessageDialog}
        onYes={handleLocaleMessageDialogYes}
      />

      {currentStep === 1 && (
        <>
          <div className={styles.stepNavigationBar}>
            <div className={styles.stepIndicator}>
              Prepare template<span className={styles.stepCount}>(Step 1/2)</span>
            </div>
            <button 
              className="primary-button next-btn"
              onClick={handleNextButtonClick}
              disabled={isLoading}
            >
              Next
            </button>

            {isLoading && (
              <div className="loading-overlay">
                <img src={loadIcon} alt="loading" className="spinner-circle-page"/>
              </div>
            )}
          </div>
          <div className={styles.documentContent}>
            <div className="contentSection">
              <div className="contentBox">
              <div className="contentBoxHeader">Add template details</div>
              <div className={styles.templateDetailsSection}>
                <div className="field-group">
                  <label htmlFor="template-title">Title*</label>
                  <div>
                    <input
                      id="template-title"
                      type="text"
                      placeholder="Enter template title"
                      maxLength={256}
                      className={`document-input ${errors.templateTitle ? 'error' : ''}`}
                      value={templateDetails.title}
                      onChange={(e) => {
                        setTemplateDetails({ ...templateDetails, title: e.target.value });
                        if (errors.templateTitle) {
                          setErrors(prev => ({ ...prev, templateTitle: '' }));
                        }
                      }}
                    />
                    {errors.templateTitle && <div className="error-message">{errors.templateTitle}</div>}
                  </div>
                </div>
                <div className="field-group">
                  <label htmlFor="template-description">Description</label>
                  <textarea
                    id="template-description"
                    placeholder="Enter template description"
                    className="document-textarea"
                    value={templateDetails.message}
                    onChange={(e) => setTemplateDetails({ ...templateDetails, message: e.target.value })}
                  />
                </div>
              </div>
              </div>
            </div>
            
            <div className="contentSection">
              <FileUploadManager
                mode="templateCreate"
                uploadedFiles={uploadedFiles}
                setUploadedFiles={setUploadedFiles}
                uploadingFiles={uploadingFiles}
                setUploadingFiles={setUploadingFiles}
                documents={documents}
                setDocuments={setDocuments}
                errors={errors}
                setErrors={setErrors}
                api={api}
                popup={popup}
                objectType={objectType}
                showToaster={showToaster}
              />
            </div>
            <div className="contentSection">
              <div className="contentBox">
              <div className="recipient-header">
                <div className="contentBoxHeader">Add role(s)</div>
                {<div className="signing-order-toggle">
                  
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={signingOrder}
                      onChange={() => setSigningOrder(!signingOrder)}
                      aria-label="Toggle signing order"
                    />
                    <span className="toggle-slider"></span>
                  </label>
                  <span>Signing Order</span>
                  <button className="help-button">
                    <span className= {`${styles.signingOrderInfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="so-tooltip"></span>
                  </button>
                  <Tooltip
                    id="so-tooltip"
                    place="top"
                    className='tooltip-info'
                    render={() => (
                      <div className="tooltip-content">
                        Enable this option to specify signing order for recipients.
                      </div>
                    )}
                  />
                </div>}
              </div>
              {errors.signerError && <div className="error-message">{errors.signerError}</div>}
              <div className={styles.recipientsList}>
                {recipients.map((recipient, index) => (                    
                  <div
                      key={recipient.id}
                      ref={el => recipientRowRefs.current[recipient.id] = el}
                      className={`recipient-data ${signingOrder ? 'so-enabled' : ''} ${dragOverId === recipient.id ? 'drag-over' : ''} ${draggingId === recipient.id ? 'dragging' : ''} ${hoveredRecipientId === recipient.id && recipient.roleType === 'signer' ? styles.recipientHoverHighlight : ''} ${styles.recipientRow}`}
                      onMouseEnter={() => setHoveredRecipientId(recipient.id)}
                      onMouseLeave={() => setHoveredRecipientId(null)}
                      draggable={signingOrder}
                      onDragStart={(e) => onDragStartHandle(e, recipient.id)}
                      onDragEnd={onDragEndHandle}
                      onDragOver={(e) => onDragOverRow(e, recipient.id)}
                      onDrop={(e) => onDropRow(e, recipient.id)}
                      onDragEnter={() => setDragOverId(recipient.id)}
                      onDragLeave={() => setDragOverId(null)}
                    >
                    <div className={styles.recipientDataSoEnabled}>
                    {signingOrder && (
                      <div
                        className={styles.dragHandle}
                        draggable={true}
                        onDragStart={(e) => onDragStartHandle(e, recipient.id)}
                        onDragEnd={onDragEndHandle}
                        title="Drag to reorder"
                      >
                        <span className={`${styles.kebabIconLeft} sfIconBase sfKebabIcon`}></span>
                        <span className={`${styles.kebabIconRight} sfIconBase sfKebabIcon`}></span>
                      </div>
                    )}
                      <div
                      role="button"
                      tabIndex={0}
                      className={`recipient-number ${signingOrder ? 'editable' : ''}`}
                      onClick={() => signingOrder && startEditingOrder(recipient.id, index + 1)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          signingOrder && startEditingOrder(recipient.id, index + 1);
                        }
                      }}
                      style={{ backgroundColor: recipientColors[recipient.id] }}
                    >
                      {editingOrderId === recipient.id ? (
                        <input
                          ref={orderInputRef}
                          type="text"
                          value={tempOrderValue}
                          onChange={handleOrderChange}
                          onKeyDown={handleOrderKeyPress}
                          onBlur={finishEditingOrder}
                          className="order-input"
                        />
                      ) : (
                        recipient.order
                      )}
                    </div>
                    </div>
                    <div className={styles.recipientGroup}>
                      {/* Top row with number, role input, and actions */}
                      <div className={styles.recipientTopRow}>
                        <div className={`${styles.roleInputGroup} ${styles.floatingLabelWrapper}`}>
                          {(focusedInputId === `role-${recipient.id}` || (recipient.roleName && recipient.roleName.trim() !== '')) && (
                            <span className={`${styles.floatingLabel} ${focusedInputId === `role-${recipient.id}` ? styles.floatingLabelActive : styles.floatingLabelStatic}`}>Role name*</span>
                          )}
                          <input
                            type="text"
                            placeholder={focusedInputId === `role-${recipient.id}` ? '' : 'Enter role*'}
                            className={`recipient-input role-input ${errors.recipients[index] && errors.recipients[index].roleName ? 'error' : ''}`}
                            value={recipient.roleName}
                            onChange={(e) => updateRecipient(recipient.id, 'roleName', e.target.value)}
                            onFocus={() => setFocusedInputId(`role-${recipient.id}`)}
                            onBlur={() => setFocusedInputId(null)}
                          />
                        </div>
                        <div className="recipient-actions">
                          {/* Role dropdown component */}
                          <div
                            className="custom-dropdown"
                            ref={el => dropdownRefs.current[`role-${recipient.id}`] = el}
                          >
                            <button
                              type="button"
                              className="dropdown-toggle-role"
                              onClick={() => toggleDropdown('role', recipient.id)}
                            >
                              <span className={`${styles.iconBase} role-icon`}>{getRoleIcon(recipient.roleType)}</span>
                              <span className = {`${styles.dropDownIcon} sfIconBase sfDropDownIcon`}></span>
                            </button>
                            {activeDropdown.type === 'role' && activeDropdown.id === recipient.id && (
                              <div className="dropdown-menu" style={{ display: 'block', position: 'absolute', zIndex: 1000 }}>
                                {recipientRoles.map(role => (
                                  <div
                                    key={role.id}
                                    role="button"
                                    tabIndex={0}
                                    className={`dropdown-item ${recipient.roleType === role.id ? 'selected' : ''}`}
                                    onClick={() => updateRecipient(recipient.id, 'roleType', role.id)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        updateRecipient(recipient.id, 'roleType', role.id);
                                      }
                                    }}
                                  >
                                    <span className="role-icon">{role.icon}</span>
                                    {role.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          {/* Language dropdown */}
                          <div
                            className="custom-dropdown"
                            ref={el => dropdownRefs.current[`language-${recipient.id}`] = el}
                          >
                            <button
                              type="button"
                              className="dropdown-toggle-language"
                              onClick={() => toggleDropdown('language', recipient.id)}
                            >
                              <span className='language-code'>{getDisplayLanguageCode(recipient.language)}</span>
                              <span className = {`${styles.dropDownIcon} sfIconBase sfDropDownIcon`}></span>
                            </button>
                            
                            {activeDropdown.type === 'language' && activeDropdown.id === recipient.id && (
                               <div className="dropdown-menu" style={{ display: 'block', position: 'absolute', zIndex: 10, maxHeight: '200px', overflowY: 'auto', overflowX: 'hidden' }}>
                                {Object.entries(languageNames).map(([code, name]) => (
                                  <div
                                    key={code}
                                    role="button"
                                    tabIndex={0}
                                    className={`dropdown-item ${recipient.language === code ? 'selected' : ''}`}
                                    onClick={() => updateRecipient(recipient.id, 'language', code)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        updateRecipient(recipient.id, 'language', code);
                                      }
                                    }}
                                  >
                                    {name} <span className="language-code">({getDisplayLanguageCode(code)})</span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={styles.roleError}>
                        {errors.recipients[index] && errors.recipients[index].roleName && (
                          <div className="input-error">{errors.recipients[index].roleName}</div>
                        )}
                      </div>
                      
                      {/* Second row with name and email*/}
                      <div className={styles.recipientDetails}>
                        <div className={`${styles.recipientName} ${styles.floatingLabelWrapper}`}>
                          {(focusedInputId === `name-${recipient.id}` || (recipient.signerName && recipient.signerName.trim() !== '')) && (
                            <span className={`${styles.floatingLabel} ${focusedInputId === `name-${recipient.id}` ? styles.floatingLabelActive : styles.floatingLabelStatic}`}>{recipient.allowEditRecipient ? 'Default recipient name' : 'Default recipient name*'}</span>
                          )}
                          <input
                            type="text"
                            placeholder={focusedInputId === `name-${recipient.id}` ? '' : recipient.allowEditRecipient ? 'Default recipient name (optional)' : 'Default recipient name*'}
                            className={`recipient-input ${errors.recipients[index] && errors.recipients[index].signerName ? 'error' : ''}`}
                            value={recipient.signerName || ''}
                            onChange={(e) => updateRecipient(recipient.id, 'signerName', e.target.value)}
                            onFocus={() => setFocusedInputId(`name-${recipient.id}`)}
                            onBlur={() => setFocusedInputId(null)}
                            id = "recipient"
                          />
                          {errors.recipients[index] && errors.recipients[index].signerName && (
                            <div className="input-error">{errors.recipients[index].signerName}</div>
                          )}
                        </div>
                        {((recipient.deliveryOption === 'Email') || (recipient.deliveryOption === 'EmailAndSMS')) && (
                        <div className={`${styles.recipientEmail} ${styles.floatingLabelWrapper}`}>
                          {(focusedInputId === `email-${recipient.id}` || (recipient.signerEmail && recipient.signerEmail.trim() !== '')) && (
                            <span className={`${styles.floatingLabel} ${focusedInputId === `email-${recipient.id}` ? styles.floatingLabelActive : styles.floatingLabelStatic}`}>{recipient.allowEditRecipient ? 'Default recipient email' : 'Default recipient email*'}</span>
                          )}
                          <input
                            type="email"
                            placeholder={focusedInputId === `email-${recipient.id}` ? '' : recipient.allowEditRecipient ? 'Default recipient email (optional)': 'Default recipient email*'}
                            className={`recipient-input ${errors.recipients[index] && errors.recipients[index].signerEmail ? 'error' : ''}`}
                            value={recipient.signerEmail}
                            onChange={(e) => updateRecipient(recipient.id, 'signerEmail', e.target.value)}
                            onFocus={() => setFocusedInputId(`email-${recipient.id}`)}
                            onBlur={() => setFocusedInputId(null)}
                          />
                          {errors.recipients[index] && errors.recipients[index].signerEmail && (
                            <div className="input-error">{errors.recipients[index].signerEmail}</div>
                          )}
                        </div>
                        )}
                        {((recipient.deliveryOption === 'SMS') || (recipient.deliveryOption === 'EmailAndSMS')) && (
                          <InternationalPhoneInput
                            value={recipient.fullPhone}
                            iso={recipient.iso}
                            nationalNumber={recipient.phone}
                            error={errors.recipients[index]?.phone}
                            styles={styles}
                            showExample={recipient}
                            containerClassName={`template-recipient-phone`}
                            placeholderMode = 'helperText'
                            showHelperText={true}
                            onChange={({ iso, countryCode, nationalNumber, fullPhone }) => {
                              updateRecipientPhone(
                                recipient.id,
                                iso,
                                countryCode,
                                nationalNumber,
                                fullPhone
                              );
                            }}
                            onFocus={() => setFocusedInputId(`phone-${recipient.id}`)}
                            onBlur={() => {
                              setFocusedInputId(null);
                            }}
                            inputProps={{
                              required: true,
                            }}
                          />
                      )}
                      </div>
                      {/* Delivery Options */}
                      <div className={styles.deliveryOptionButton}>
                        <label aria-label='Select Delivery Option'>
                          <input
                            type="checkbox"
                            className={styles.deliveryOptionInput}
                            checked={recipient.showDeliveryOptions}
                            onChange={() => toggleOption(recipient.id, "delivery")}
                          />
                          <div className={styles.deliveryOption}>
                            <span className={`${styles.sfIconBase} ${styles.sfSendNowIcon}`} style={{ fontSize: "15px" }}></span>
                            <span className={styles.deliveryOptionText}>{recipient.deliveryOption === 'SMS' ? 'SMS' : recipient.deliveryOption === 'Email' ? 'Email' : 'Email & SMS'}</span>
                            <span className={recipient.showDeliveryOptions ? `${styles.sfIconBase} ${styles.sfWrapUp}` : `${styles.sfIconBase} ${styles.sfDropDown}`}></span>
                          </div>
                        </label>
                        {/* Settings Option */}
                        <label aria-label="Settings">
                          <input
                            type ="checkbox"
                            className = {styles.settingsOptionInput}
                            checked = {recipient.showSettingsOptions}
                            onChange = {() => toggleOption(recipient.id, "settings")}
                          />
                          <div className={styles.deliveryOption}>
                            <span className={`${styles.sfIconBase} ${styles.sfGearIcon} sfIconBase sfGearIcon`} style={{ fontSize: "15px" }}></span>
                            <span className={styles.deliveryOptionText}>Settings</span>
                            <span className={recipient.showSettingsOptions  ? `${styles.sfIconBase} ${styles.sfWrapUp}`  : `${styles.sfIconBase} ${styles.sfDropDown}`}></span>
                          </div>
                        </label>
                        {!recipient.showSettingsOptions && recipient.authSetting && (() => {
                          const result = authTypeToShow(recipient);
                        
                          return (
                            <div className={styles.knowAuth}>
                              <span className={`${styles.sfIconBase} ${styles.sfTickIcon} ${result.isError ? styles.sfTickIconError : ''}  sfIconBase sfTickIcon`}></span>
                              <span className= {`${result.isError ? styles.authError : ''}`}>{result.text}</span>
                            </div>
                          );
                        })()}
                      </div>
                      {recipient.showDeliveryOptions && (
                        <div className={styles.deliveryOptionInfo}>
                          <div className={styles.TitleContainer}>
                            <span className={styles.deliveyOptionTitle}>Delivery Option </span>
                            <button className = {styles.helpButton}>
                              <span className = {`${styles.iconBase} ${styles.deliveryOptionInfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="do-tooltip"></span>
                            </button>
                            <Tooltip
                              id="do-tooltip"
                              place="right"
                              className='tooltip-info tip-delivery-options'
                              clickable
                              render={() => (
                                <div className="tooltip-content">
                                  Choose a delivery mode for notifications. For more<br /> information, see <a href='https://support.boldsign.com/kb/article/13965/send-signature-requests-via-sms' target="_blank" rel="noopener noreferrer" className={styles.tooltipLink}>delivery options<span className={styles.sfIconOpenLink}></span></a>.
                                </div>
                              )}
                            />
                          </div>
                          <div className={styles.deliveryOptionsContainer}>
                            <label className={styles.deliveryOptions}>
                              <input
                                type="radio"
                                name={`deliveryOption-${recipient.id}`}
                                id={`emailDelivery-${recipient.id}`}
                                value="Email"
                                checked={recipient.deliveryOption === 'Email'}
                                onChange={() => handleDeliveryOptionChange(recipient.id, 'Email')}
                                className={styles.radioIcon}
                              />
                              <span className = {styles.availableDeliveyOptions}>Email</span>
                            </label>
                            <label className={styles.deliveryOptions}>
                              <input
                                type="radio"
                                name={`deliveryOption-${recipient.id}`}
                                id={`smsDelivery-${recipient.id}`}
                                value="SMS"
                                checked={recipient.deliveryOption === 'SMS'}
                                onChange={() => handleDeliveryOptionChange(recipient.id, 'SMS')}
                                className={styles.radioIcon}
                              />
                              <span className = {styles.availableDeliveyOptions}>SMS</span>
                            </label>
                            <label className={styles.deliveryOptions}>
                              <input
                              type="radio"
                              name={`deliveryOption-${recipient.id}`}
                              id={`smsDelivery-${recipient.id}`}
                              value="EmailAndSMS"
                              checked={recipient.deliveryOption === 'EmailAndSMS'}
                              onChange={() => handleDeliveryOptionChange(recipient.id, 'EmailAndSMS')}
                              className={styles.radioIcon}
                              />
                              <span className = {styles.availableDeliveyOptions}>Email & SMS</span>
                            </label>
                          </div>
                        </div>
                      )}
                      {recipient.showSettingsOptions && (
                        <div className={styles.settingsWrapper}>
                          {/* LEFT SECTION */}
                          <div className={styles.settingsLeft}>
                            <div className={styles.sectionTitle}>Allow sender to</div>

                            <label className={`${styles.checkboxOption} ${styles.checkboxOptionTemplate}`}>
                              <label className={styles.customCheckbox} aria-label='option'>
                              <input
                                type="checkbox"
                                checked = {recipient.allowEditRecipient}
                                onChange={() => {handleRecipientAccess(recipient.id, "edit")}}
                              />
                              <span className={styles.checkmark}></span>
                            </label>
                              <span className={styles.senderOptions}>Edit this recipient</span>
                            </label>

                            <label className={`${styles.checkboxOption} ${styles.checkboxOptionTemplate}`}>
                              <label className={styles.customCheckbox} aria-label='option'>
                              <input
                                type="checkbox"
                                checked = {recipient.allowDeleteRecipient}
                                onChange={() => {handleRecipientAccess(recipient.id, "delete")}}
                                disabled={!recipient.allowEditRecipient}
                              />
                              <span className={styles.checkmark}></span>
                            </label>
                              <span className={styles.senderOptions}>Delete this recipient</span>
                            </label>

                            <hr className={styles.divider} />

                            <label className={`${styles.checkboxOption} ${styles.checkboxOptionTemplate}`}>
                              <label className={styles.customCheckbox} aria-label='option'>
                              <input
                                type="checkbox"
                                disabled = {recipient.roleType === 'reviewer'}
                                checked={recipient.allowFieldConfigurationSetting}
                                onChange={() => {handleRecipientAccess(recipient.id, "fieldConfig")}}
                              />
                              <span className={styles.checkmark}></span>
                            </label>
                              <span className={styles.senderOptions}>Allow Field Configuration</span>
                              <button className={`${styles.fieldHelpButton} help-button`}>
                                <span className = {`${styles.iconBase} ${styles.fielConfigurationinfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="field-tooltip"></span>
                              </button>
                              <Tooltip
                                id="field-tooltip"
                                place="top"
                                className={`${styles.tooltipField} tooltip-fieldInfo`}
                                render={() => (
                                  <div className="tooltip-content">
                                    Enable this feature to allow signers to add the required fields by dragging and dropping them into the document during the signing process.
                                  </div>
                                )}
                              />
                            </label>
                          </div>

                          {/* RIGHT SECTION */}
                          <div className={styles.settingsRight}>
                            <div className={styles.sectionTitle}>
                              Impose authentication
                            </div>

                            {/* NONE */}
                            <label className={styles.radioOption}>
                              <input
                                type="radio"
                                name={`auth-${recipient.id}`}
                                checked={recipient.authType === "none"}
                                onChange={() => handleAuthTypeChange(recipient.id, "none")}
                                className={styles.settingRadioIcon}
                              />
                              <span>None</span>
                            </label>

                            {/* ACCESS CODE */}
                            <label className={styles.radioOption}>
                              <input
                                type="radio"
                                name={`auth-${recipient.id}`}
                                checked={recipient.authType === "accessCode"}
                                onChange={() => handleAuthTypeChange(recipient.id, "accessCode")}
                                className={styles.settingRadioIcon}
                              />
                              <span>Access code</span>
                            </label>

                            {/* EMAIL OTP */}
                            <label className={styles.radioOption}>
                              <input
                                type="radio"
                                name={`auth-${recipient.id}`}
                                checked={recipient.authType === "email"}
                                onChange={() => handleAuthTypeChange(recipient.id, "email")}
                                disabled={recipient.deliveryOption === "SMS"}
                                className={styles.settingRadioIcon}
                              />
                              <span className={recipient.deliveryOption === "SMS" ? styles.disabledText : ""}>
                                Email OTP (One Time Password)
                              </span>
                            </label>

                            {/* SMS OTP */}
                            <label className={styles.radioOption}>
                              <input
                                type="radio"
                                name={`auth-${recipient.id}`}
                                checked={recipient.authType === "SMS"}
                                onChange={() => handleAuthTypeChange(recipient.id, "SMS")}
                                className={styles.settingRadioIcon}
                              />
                              <span>SMS OTP</span>
                            </label>
                          </div>
                        </div>
                      )}
                      {/* Delivery Options End */}
                    </div>
                    {recipients.length > 1 && (
                          <div className={` ${styles.delete} delete`}>
                            <button
                              onClick={() => removeRecipient(recipient.id)}
                            >
                              <span className={`${styles.iconBase} ${styles.deleteIcon} sfIconBase sfDeleteIcon`}></span>
                            </button>
                          </div>
                        )}
                  </div>
                ))}
              </div>
              <button
                className={styles.addRecipientButton}
                onClick={addRecipient}
                data-tooltip-id={recipients.length >= MAX_RECIPIENTS ? "max-role-tooltip" : undefined}
              >
                <span className = {`${styles.iconBase} ${styles.addIcon} sfIconBase sfAddIcon`}></span> Add role
              </button>
              <Tooltip
                id="max-role-tooltip"
                place="top"
                className="tooltip-info"
                render={() => (
                  <div className="tooltip-content">
                    Maximum recipient count should be less than or equal to {MAX_RECIPIENTS}
                  </div>
                )}
              />
            </div>
            </div>
            <div className="contentSection">
              <AddCC
                recipients={recipients}
                errors={errors}
                setErrors={setErrors}
                showToaster={showToaster}
                enableSuggestions={false}
                onCcChange={setCcEmailTags}
              />
            </div>
            <div className="contentSection">
              <div className="contentBox">
              <div className="contentBoxHeader">Document</div>
              <div className="document-fields">
                {(() => {
                  const tabs = getUniqueRecipientLocales();
                  const noUnique = tabs.length === 1 ? tabs[0] : null;
                  const displayedLocale = noUnique || activeLocale;
                  const active = displayedLocale ? (documentInfo[displayedLocale] || { title: '', message: '' }) : documents;

                  return (
                    <>
                      {tabs.length > 1 && (
                        <div role="tablist" aria-label="Document title language" className={styles.tabList}>
                          {tabs.map((loc) => {
                            const isActive = loc === activeLocale;
                            return (
                              <button
                                key={loc}
                                type="button"
                                role="tab"
                                aria-selected={isActive}
                                onClick={() => setActiveLocale(loc)}
                                className={isActive ? `${styles.tabActive} ${styles.tab}` : styles.tab}
                              >
                                {languageNames[loc]}&nbsp;({loc})
                              </button>
                            );
                          })}
                        </div>
                      )}
                      <div className="field-group">
                        <label htmlFor="document-title" className={styles.titleLabel}>
                          <span>Title</span>
                          <span className = {`${styles.iconBase} ${styles.titleInfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="title-tooltip"></span>
                        </label>
                        <Tooltip
                          id="title-tooltip"
                          place="right"
                          className='tooltip-info tip-title'
                          render={() => (
                            <div className="tooltip-content">
                              This is the document name that will be shown within the BoldSign user interface and also in the signature request email.
                            </div>
                          )}
                        />
                        <input
                          id="document-title"
                          type="text"
                          placeholder="Enter document title*"
                          className={`document-input ${errors.title ? 'error' : ''}`}
                          value={active.title || ''}
                          onChange={(e) => updateDocumentInfoField(displayedLocale, 'title', e.target.value, active)}
                        />
                        {errors.title && <div className="error-message">{errors.title}</div>}
                      </div>
                      <div className="field-group">
                        <label htmlFor="document-message">Message</label>
                        <textarea
                          id="document-message"
                          placeholder="Enter message for all recipients"
                          className="document-textarea"
                          value={active.message || ''}
                          onChange={(e) => updateDocumentInfoField(displayedLocale, 'message', e.target.value, active)}
                        />
                      </div>
                    </>
                  );
                })()}
              </div>
              </div>            
            </div>
            <div className="contentSection">
              <div className="contentBox">
                <div className="contentBoxHeader">Template Settings</div>
                <div className='field-group'>
                  <label htmlFor="template-tags-input" className=''>
                    <span className={`${styles.templateTags}`}>Tags</span>
                    <span className={`${styles.titleInfoIcon} sfIconBase sfInfoIcon`} data-tooltip-id="templateTag-tooltip"></span>
                  </label>
                  <Tooltip
                    id="templateTag-tooltip"
                    place="right"
                    className='tooltip-info tip-templateTag'
                    render={() => (
                      <div className="tooltip-content">
                        Add tags to the templates for better organization and filtering on the listing page.
                      </div>
                    )}
                  />
                  <div className={styles.tagsInput}>
                    {templateTags.map((tag, index) => (
                      <div key={index} className={styles.tagChip}>
                        <span>{tag}</span>
                        <button
                          type="button"
                          onClick={() => setTemplateTags(prev => prev.filter(existingTag => existingTag !== tag))}
                          className={`${styles.removeTag}`}
                          aria-label={`Remove ${tag}`}
                        >
                          <span className={`sfIconBase sfCloseIcon ${styles.closeIcon}`}></span>
                        </button>
                      </div>
                    ))}
                    <input
                      id="template-tags-input"
                      type="text"
                      value={templateTagInput}
                      placeholder={templateTags.length === 0 ? 'Enter one or more tags separated by a comma.' : ''}
                      onChange={event => setTemplateTagInput(event.target.value)}
                      onKeyDown={handleTemplateTagKeyDown}
                      onPaste={handleTemplateTagPaste}
                      onBlur={() => addTemplateTags(templateTagInput)}
                      className={styles.tagInputField}
                      maxLength="50"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="contentSection">
              <div className="contentBox">
                <div className="contentBoxHeader">Template Usage Settings</div>
                <div className={styles.templateUsageSettings}>
                  <div>
                    <span className={styles.checkboxOptionTitle}>Files</span>
                    <label className={`${styles.checkboxOption} ${styles.checkboxOptionContent}`}>
                      <label className={styles.customCheckbox} aria-label='option'>
                        <input
                          type="checkbox"
                          checked={usageSettings.allowNewFiles}
                          onChange={() => handleUsageSettingChange('allowNewFiles')}
                        />
                        <span className={styles.checkmark}></span>
                      </label>
                      <span className={styles.senderOptions}>Allow sender to add more files</span>
                    </label>
                  </div>
                  <div>
                    <span className={styles.checkboxOptionTitle}>Recipients</span>
                    <label className={`${styles.checkboxOption} ${styles.checkboxOptionContent}`}>
                    <label className={styles.customCheckbox} aria-label='option'>
                    <input
                      type="checkbox"
                      checked={usageSettings.allowNewRoles}
                      onChange={() => handleUsageSettingChange('allowNewRoles')}
                    />
                    <span className={styles.checkmark}></span>
                    </label>
                      <span className={styles.senderOptions}>Allow sender to add more Recipients</span>
                    </label>
                  </div>
                  <div>
                    <span className={styles.checkboxOptionTitle}>Document Message</span>
                    <label className={`${styles.checkboxOption} ${styles.checkboxOptionContent}`}>
                    <label className={styles.customCheckbox} aria-label='option'>
                    <input
                      type="checkbox"
                      checked={usageSettings.allowMessageEditing}
                      onChange={() => handleUsageSettingChange('allowMessageEditing')}
                    />
                    <span className={styles.checkmark}></span>
                    </label>
                      <span className={styles.senderOptions}>Allow sender to edit the document message before sending</span>
                    </label>
                  </div>
                  <div>
                    <span className={styles.checkboxOptionTitle}>Field Configuration</span>
                    <label className={`${styles.checkboxOption} ${styles.checkboxOptionContent}`}>
                    <label className={styles.customCheckbox} aria-label='option'>
                    <input
                      type="checkbox"
                      checked={usageSettings.formFieldPermission.canAdd}
                      onChange={() => handleUsageSettingChange('formFieldPermission.canAdd')}
                    />
                    <span className={styles.checkmark}></span>
                    </label>
                      <span className={styles.senderOptions}>Allow sender to add new fields</span>
                    </label>
                    <label className={`${styles.checkboxOption} ${styles.checkboxOptionContent}`}>
                    <label className={styles.customCheckbox} aria-label='option'>
                    <input
                      type="checkbox"
                      checked={usageSettings.formFieldPermission.canModify}
                      onChange={() => handleUsageSettingChange('formFieldPermission.canModify')}
                    />
                    <span className={styles.checkmark}></span>
                    </label>
                      <span className={styles.senderOptions}>Allow sender to edit or delete fields</span>
                    </label>
                    <label className={`${styles.checkboxOption} ${styles.checkboxOptionContent}`}>
                    <label className={styles.customCheckbox} aria-label='option'>
                    <input
                      type="checkbox"
                      checked={usageSettings.formFieldPermission.canModifyDefaultValue}
                      disabled={usageSettings.formFieldPermission.canModify}
                      onChange={() => handleUsageSettingChange('formFieldPermission.canModifyDefaultValue')}
                    />
                    <span className={styles.checkmark} data-tooltip-id= {usageSettings.formFieldPermission.canModify ? 'template-field-permission-tooltip' : ''}></span>
                    </label>
                      <span className={usageSettings.formFieldPermission.canModify ? `${styles.senderOptions} ${styles.checkBoxDisabled}` :`${styles.senderOptions}`}>Allow sender to set default values only for fields</span>
                    </label>
                    <Tooltip
                      id="template-field-permission-tooltip"
                      place="right"
                      className="tooltip-info tip-canSetValues"
                      render={() => (
                        <div className="tooltip-content">
                          This permission is granted by “Edit or Delete fields” and can&apos;t be changed while it&apos;s enabled.
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <DocumentSettingsSection
              brandsList={brandsList}
              onSettingsChange={handleSettingsChange}
              mode="template"
            />
          </div>
        </>
      )}
      {currentStep === 2 && (
        <div className={styles.iframeContainer}>
          <iframe 
            ref={iframeRef}
            src={iframeSrc} 
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="Document Preview"
          />
        </div>
      )}
    </div>
  );
};
export default TemplateCreate;
